import React, { useState, useEffect, useRef } from "react";
import CommonButton from "../../common/component/commonButton";
import Actionicon from '../../assests/images/action.png'
import arrowLeft from '../../assests/images/arrow-circle-left.png';
import arrowRight from '../../assests/images/arrow-circle-right.png';
import StepperModal from "../../common/component/commonStepper";
import { useForm } from "react-hook-form";
import useValidation from "../../common/utils/validationRules";
import { useDispatch, useSelector } from 'react-redux';
import { useLoader } from "../../common/component/LoaderProvider";
import { AddStructure, DeleteStructure, getByIdStructure, updateStructure, updateStructureContact } from "../../service/action/actioncreator/StructureAction.jsx/Structure";
import { OverlayPanel } from "primereact/overlaypanel";
import CommonPhoneInput from "../../common/component/commonPhoneInput";
import ConfirmAlert from "../../common/component/commonAlert";
import CommonCountryFlage from "../../common/component/CommonCountryFlage";
import { useTranslation } from "react-i18next";
import { useToast } from "../../common/component/Toast";
import CommonFlag from "../../common/component/commonFlag";

const HospitalRetailContact = ({  HospitalID,regionDropdown,pharmacyViewData,rowDataView}) => {

  const pharmacyContactData= useSelector(state=>state.retailReducer.retailGetIdResponse)

  
    const dispatch = useDispatch();
    var userId = localStorage.getItem("userId");

    const [currentPage, setCurrentPage] = useState(1);
    const [displayData, setDisplayData] = useState([]);
    const [progress, setProgress] = useState(33);
    const [currentStep, setCurrentStep] = useState(1);
    const { validateField } = useValidation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    // const { showLoader, hideLoader } = useLoader();
    const [selectedData, setSelectedData] = useState("");
    const [showConfirm, setShowConfirm] = useState(false)
    const [modify, setModify] = useState(false)
    const overlayPanelRef = useRef(null);
    const [countryCode,setCountryCode]=useState();
    const [updateContact,setUpdateContact]=useState([])
    const [countryDialCode, setCountryDialCode] = useState("");

    const [rowdatavalue, setrowDataValue] = useState({
        ContactListRowData: "",
        ContactListRowDataID: '',
        ContactListRowDataEdit: false,
        ContactListRowDataDelete: "",
    })
    // var payload={
    //     phoneNumber:`${countryDialCode} ${getValuesPatient('PatientPhoneNumber')?.slice(countryDialCode.length)}`
    // }
    const { t } = useTranslation("translation");
    const {showLoader, hideLoader, loadingStepper, showStepperLoader, hideStepperLoader,} = useLoader();
      const { showToast } = useToast();

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        control,
        reset,
        watch,
        trigger,
    } = useForm({ mode: "onChange" });

    watch('Nome');
    watch("cogNome");
    watch("Ruolo");
    watch("PhoneNumber");
    

    const handleThreeDotsClick = (event, data, rowid) => {
        setrowDataValue({
            ...rowdatavalue, ContactListRowData: data,
            ContactListRowDataID: rowid,
        });
        setSelectedData(data)
        // setSelectedRowData(rowData); 
        overlayPanelRef.current?.toggle(event);
    };

    const handleOptionClick = (option) => {
        // console.log("845961581", option);

        // if (onRegisterData) {
        //   onRegisterData({ action: option, ...selectedRowData });

        // }
        // overlayPanelRef.current.hide();
    };

    const stepConfigs = {
        1: [
            {
                // title: "Step 1",
                // titleMain:`Contatto di riferimento`,
                textFooter: `Inserisci i dati relativi al nuovo contatto`,
                fields: [
                    { type: "heading", content: `Nominativo`, style: false },
                    { name: "Nome", type: "text", placeholder: `Nome`, validation: true },
                    { name: "Cognome", type: "text", placeholder: `Cognome`, validation: true },
                    { type: "heading", content: `Ruolo`, style: false },
                    { name: "Ruolo", type: "text", placeholder: `Ruolo`, validation: true, formatOptions: false },
                    { type: "heading", content: `Telefono`, style: false },
                    { name: "PhoneNumber", type: "phoneNumber", placeholder: `Telephone*`, validation: true, formatOptions: false },
                    {
                        type: "button", label: `Conferma`, disabled:
                            getValues("Nome")?.length == 0 ||
                            getValues("Cognome")?.length == 0 ||
                            getValues("Ruolo")?.length == 0 ||
                                !(
                                    getValues("PhoneNumber")?.slice(countryDialCode?.length)
                                     .length >= 10
                                )
                    },
               
                ],
            },
        ],

    };

    const clearedit = () => {
        return (setValue('Nome', ""),
            setValue('Cognome', ""),
            setValue('Ruolo', ""),
            setValue('PhoneNumber', ""))
    }

    const roleBasedSteps = stepConfigs[1];
    const ITEMS_PER_PAGE = 10;

    const handleModalClose = () => {
        clearedit()
        setModify(false)
        setIsModalOpen(false);
        setIsSuccess(false)
        // setOtpSelectionFlag(false);
        // setOtpCodeFlag(false)
        // setViewdata(false)
        // reset()
        // resetOtp();
        // hideStepperLoader()
    };

    const structureUpdateResponseData = useSelector(
        (state) => state.structureReducer.structureDeleteError

    );

    const ContactListEdit = () => {
        setModify(true)
        setIsModalOpen(true)
        setValue('Nome', selectedData?.contactName)
        setValue('Cognome', selectedData?.contactSurname)
        setValue('Ruolo', selectedData?.role)
        setValue('PhoneNumber', selectedData?.phoneNumber)

    }

    const ContactListDelete = () => {
        if(pharmacyContactData?.contacts?.length == 1){
            setShowConfirm(false)
            showToast("warn","Attenzione","È obbligatorio fornire almeno un numero di contatto")
        }else{
            setShowConfirm(true)
        }
    }
    const AddContact = () => {
        setModify(false)
        setIsModalOpen(true)
    }


    const onHide = () => {
        setShowConfirm(false);

    };
    const onConfirm = () => {
        var headers = {
            UserId: userId,
            AccessIdentifier: "Validate"
        };
        let ID =rowdatavalue?.ContactListRowDataID;
        let pharmacyViewDataID = pharmacyViewData.id;
        let retailFlag =true
        let pharmacyID =pharmacyViewData.id
        let AddStructureDataDelete ={ID,headers,showLoader,hideLoader,showToast,t,pharmacyID,retailFlag}
        dispatch(DeleteStructure(AddStructureDataDelete))
        setShowConfirm(false);
    };
    const handleCloseSubmission=()=>{
        setIsModalOpen(false)

        setIsSuccess(false)        
    }
    const handleModalSubmit = () => {
        // console.log("check11");
      };
        const handleSubmitStep=()=>{
            if(modify){
                var headers = {
                    AccessIdentifier: "Validate"
                };
              const   payload = {
                    id: rowdatavalue.ContactListRowData.id,
                    pharmacyId: pharmacyViewData?.id,
                    contactName: getValues('Nome'),
                    contactSurname: getValues('Cognome'),
                    role: getValues('Ruolo'),
                    phoneNumber: `${countryDialCode} ${getValues('PhoneNumber')?.slice(countryDialCode?.length)}`,
                    isActive: true
                };
                let ID =rowdatavalue?.ContactListRowDataID;
                let retailFlag=true
                let pharmacyID =pharmacyViewData.id

                let AddStructureDataUpdate ={payload,ID,headers,showLoader,hideLoader,showToast,t,retailFlag,pharmacyID}
                
                
                dispatch(updateStructureContact(AddStructureDataUpdate,setIsModalOpen));
                // reset()
                handleModalClose();
                setModify(false)
            }else {
                let payload = { contactName: getValues('Nome'), role: getValues('Ruolo'), contactSurname: getValues('Cognome'),
                    phoneNumber: `${countryDialCode} ${getValues('PhoneNumber')?.slice(countryDialCode?.length)}`,pharmacyId: pharmacyViewData?.id }
                 let retailFlag=true
                 let pharmacyID =pharmacyViewData.id
                let AddStructureData ={payload, showLoader, hideLoader, showToast, t,retailFlag, pharmacyID}
                dispatch(AddStructure(AddStructureData,setIsSuccess,setIsModalOpen));
                // dispatch(AddStructure(payload, showLoader, hideLoader, showToast, t, HospitalID,));
                // setIsSuccess(true)
                // reset()
                handleModalClose();
                setModify(false)
            }
        }
        const handleCountryChange = (value) => {
            setCountryDialCode(value.dialCode);
          }

    return (
        <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        

            <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '85%', marginBottom: 10 }}>
                    <div style={{
                        display: 'flex', justifyContent: 'center', padding: '10px', fontWeight: 'bold',
                    }}>
                        <div style={{ flex: 1 }}>Nome</div>
                        <div style={{ flex: 1 }}>Cognome</div>
                        <div style={{ flex: 1 }}>Ruolo</div>
                        <div style={{ flex: 1 }}>Telefono</div>
                        <div style={{}}></div>
                        {/* <div style={{}}></div> */}
                    </div>
                    {pharmacyContactData?.contacts?.map((contact) => (
                        <div key={contact.id} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', border: '0 solid #ddd', marginBottom: '10px',
                            backgroundColor: '#f6fafc'
                        }}>
                            <div style={{ flex: 1 }}>{contact?.contactName}</div>
                            <div style={{ flex: 1 }}>{contact?.contactSurname}</div>
                            <div style={{ flex: 1 }}>{contact?.role}</div>
                            <div style={{ flex: 1, display: 'flex', gap: '15px',justifyContent:'flex-start' ,alignItems: 'center' }}>
                            {CommonFlag(contact?.countryCode,contact?.phoneNumber)}

                            </div>
                            {rowDataView?.isActive &&<div style={{}}>
                                <img src={Actionicon} style={{ width: "30px", height: '30px', borderRadius: '100%', }}
                                    onClick={(e) => handleThreeDotsClick(e, contact, contact.id)}
                                />
                            </div>}
                        </div>
                    ))}
                </div>
            </div>
            

            {isModalOpen &&

                <StepperModal
                    selectedData={selectedData}
                    isModalOpen={isModalOpen}
                    handleModalClose={handleModalClose}
                    currentStep={currentStep}
                    getValues={getValues}
                    hospitalfacilitiesSuccess={true}
                    isSuccess={isSuccess}
                    control={control}
                    errors={errors}
                    register={register}
                    validateField={validateField}
                    handleSubmit={handleSubmit}
                    watch={watch}
                    roleBasedSteps={roleBasedSteps}
                    // onSubmit={handleSubmit(modify ? handleModalSubmitforUpdate : handleModalSubmit)}
                    onSubmit={handleSubmit(handleModalSubmit)}
                    handleSubmitStep={handleSubmitStep}
                    onCountryChange={handleCountryChange}
                    trigger={trigger}
                    setProgress={setProgress}
                    setCurrentStep={setCurrentStep}
                    mainTitle={"Nuovo Contatto"}
                    progressHide={true}
                    handleCloseSubmission={handleCloseSubmission}
                     size="lg"
                />
            }

            <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
                <div className="popover-menu">
                    <div onClick={() => ContactListEdit()} className="popover-option" > Modifica </div>
                    <div onClick={() => ContactListDelete()} className="popover-option" > Elimina </div>
                </div>
            </OverlayPanel>

            <ConfirmAlert
                visible={showConfirm}
                onHide={onHide}
                 message={t("text_confirm_msg_remove_user")}

                onConfirm={onConfirm}
                />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', gap: 10 }}>
                <CommonButton label={t("text_contact_created")} onClick={() => AddContact()} color="primary" variant="success"
                                  disabled={rowDataView?.isActive == true ? false : true}

                    className="btn btn-success mt-3 p-2 w-20 input-style-common text-white" inputStyle={true} />
                    <CommonButton
                    disabled={true}
                    label={t("text_export_list")} onClick={() => console.log("Export list")} color="secondary"
                    className={`btn btn-cancel  mb-3 input-style-common btn-cancel-style btn-padding primary-text-color `} variant={"cancel"} inputStyle={true} />
            </div>

        </div>
    );
};

export default HospitalRetailContact;





